<template>
  <div class="sticky top-0 bg-white md:z-50">
    <div class="border-b">
      <div class="container py-3 mx-auto">
        <div class="mx-auto md:max-w-6xl">
          <div
            class="justify-between hidden w-full mx-auto md:flex md:space-x-2"
          >
            <input
              v-model="keyword"
              type="text"
              class="flex-shrink px-4 py-2 bg-gray-50 border-[#ccc] focus:outline outline-primary outline-1 md:w-[500px] h-[48px] focus:border-0 rounded-xl border text-base placeholder:tracking-wide placeholder:font-light text-gray-600"
              placeholder="City, Community, Building or developer"
            />

            <!-- Property type dropdown -->
            <div v-if="property_types" class="w-auto">
              <DropDown
                height="[48px]"
                button-label="Property Type"
                radius="lg"
                :menu-items="property_types.data"
                unique-identifier="property-types"
                @menu-item-selected="handleMenuItemSelected"
              />
            </div>

            <!-- Beds & Baths dropdown -->
            <div class="w-auto">
              <DropdownBed
                radius="lg"
                height="[48px]"
                button-label="Beds & Baths"
                @bed-selected="handleBathBedSelected"
              />
            </div>

            <!-- Price dropdown -->
            <div class="w-auto">
              <PriceDropdown
                radius="lg"
                height="[48px]"
                @price-range-selected="handlePriceRangeSelected"
                button-label="Price"
              />
            </div>

            <div v-if="property_types" class="w-auto">
              <DropDown
                height="[48px]"
                button-label="Project Status"
                radius="lg"
                :menu-items="project_status"
                unique-identifier="project-status"
                @menu-item-selected="handleMenuItemSelected"
              />
            </div>

            <!-- Find button -->
            <button
              @click="filterProjects"
              class="flex items-center justify-center w-20 h-[48px] px-2 py-1 text-white bg-primary rounded-lg hover:bg-[#910811]"
            >
              Find
            </button>
          </div>
          <div class="flex flex-col w-full mx-auto md:hidden">
            <div class="mb-3 w-12/12">
              <input
                v-model="keyword"
                type="text"
                class="md:w-[500px] w-full h-[48px] focus:ring-primary focus:border-primary focus:border-0 px-4 py-2 bg-gray-100 rounded-xl border border-gray-100 text-base placeholder:tracking-wide placeholder:font-light text-gray-600"
                placeholder="City, Community, Building or developer"
              />
            </div>
            <vue-horizontal
              responsive
              :button="false"
              ref="horizontal"
              class="space-x-3"
              @scroll-debounce="onScrollDebounce"
            >
              <div class="flex items-center justify-between space-x-3">
                <!-- Property type dropdown -->
                <div v-if="property_types" class="w-auto">
                  <DropDown
                    height="[35px]"
                    button-label="Property Type"
                    radius="lg"
                    :menu-items="property_types.data"
                    unique-identifier="property-types"
                    @menu-item-selected="handleMenuItemSelected"
                  />
                </div>

                <!-- Beds & Baths dropdown -->
                <div class="w-auto">
                  <DropdownBed
                    radius="lg"
                    height="[35px]"
                    button-label="Beds & Baths"
                    @bed-selected="handleBathBedSelected"
                  />
                </div>

                <!-- Price dropdown -->
                <div class="w-auto">
                  <PriceDropdown
                    radius="lg"
                    height="[35px]"
                    @price-range-selected="handlePriceRangeSelected"
                    button-label="Price"
                  />
                </div>

                <div v-if="property_types" class="w-auto">
                  <DropDown
                    height="[35px]"
                    button-label="Project Status"
                    radius="lg"
                    :menu-items="project_status"
                    unique-identifier="project-status"
                    @menu-item-selected="handleMenuItemSelected"
                  />
                </div>

                <!-- Find button -->
                <button
                  @click="filterProjects"
                  class="flex items-center justify-center w-20 h-[35px] px-2 py-1 text-white bg-primary rounded-lg hover:bg-[#910811]"
                >
                  Find
                </button>
              </div>
            </vue-horizontal>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="px-4 md:px-0">
    <div class="flex flex-col mx-auto md:flex-row">
      <SearchFilter
        :project-count="projectCount"
        :cities-count="citiesWithProjectCounts"
        :projects="properties"
        @get-properties-by-city-id="handlePropertiesByCityId"
        @project-sorting="handlePropertiesByCityId"
      />
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from "vue";
import SearchFilter from "@/features/new-projects/SearchFilterView.vue";
import { useStore } from "vuex";
import DropDown from "@/components/form-components/DropDown.vue";
import DropdownBed from "@/components/form-components/BedDropdown.vue";
import PriceDropdown from "@/components/form-components/PriceDropdown.vue";
import axios from "axios";
import VueHorizontal from "vue-horizontal";
export default {
  name: "PropertiesView",
  components: {
    SearchFilter,
    DropDown,
    DropdownBed,
    PriceDropdown,
    VueHorizontal,
  },

  setup() {
    const store = useStore();
    const base_url = store.state.baseUrl;
    const properties = ref([]);
    const property_types = ref([]);
    const project_status = [
      { name: "Upcoming", value: "upcoming" },
      { name: "Under Construction", value: "under construction" },
      { name: "Completed", value: "completed" },
    ];

    const propertyType = ref("");
    const status = ref("");
    const keyword = ref("");
    const minPrice = ref("");
    const maxPrice = ref("");
    const numBed = ref("");
    const citiesWithProjectCounts = ref(null);
    const projectCount = ref(null);

    const getPropertyTypes = () => {
      axios
        .get(`${base_url}property-types`)
        .then((response) => {
          property_types.value = response.data;
        })
        .catch((error) => console.log(error));
    };

    const getProjects = () => {
      axios
        .get(`${base_url}new-projects`)
        .then((response) => {
          properties.value = response.data.data;
          projectCount.value = response.data.data.length;
        })
        .catch((error) => console.log(error));
    };

    const handleMenuItemSelected = (payload) => {
      if (payload.dropdownIdentifier === "property-types") {
        propertyType.value = payload.itemId;
      } else if (payload.dropdownIdentifier === "project-status") {
        status.value = payload.itemId;
      }
    };

    const handlePriceRangeSelected = (payload) => {
      minPrice.value = payload.minPrice;
      maxPrice.value = payload.maxPrice;
    };

    const handleBathBedSelected = (payload) => {
      numBed.value = payload.Bedroom.value;
    };

    const filterProjects = async () => {
      try {
        // Construct queryParams with all possible parameters
        const queryParams = {
          keyword: keyword.value ?? "",
          property_type: propertyType.value ?? "",
          beds: numBed.value ?? "",
          min_price: minPrice.value ?? "",
          max_price: maxPrice.value ?? "",
          status: status.value ?? "",
        };

        // Filter out any parameters that are empty
        const filteredParams = Object.fromEntries(
          // eslint-disable-next-line no-unused-vars
          Object.entries(queryParams).filter(([_, v]) => v !== "")
        );

        const response = await axios.get(`${base_url}filter-projects`, {
          params: filteredParams,
        });

        properties.value = response.data.data;
        projectCount.value = response.data.data.length;
      } catch (error) {
        console.error(error.message);
      }
    };

    const getCitiesWithProjectCounts = async () => {
      try {
        const response = await axios.get(
          `${base_url}cities-with-project-counts`
        );
        citiesWithProjectCounts.value = response.data;
      } catch (error) {
        console.error(
          "Error fetching cities with project counts:",
          error.message
        );
      }
    };

    const handlePropertiesByCityId = async (payload) => {
      try {
        const queryParams = {
          city_id: payload.cityId,
          sort_by: payload.itemId,
        };

        const filteredParams = Object.fromEntries(
          // eslint-disable-next-line no-unused-vars
          Object.entries(queryParams).filter(([_, v]) => v !== "")
        );

        const response = await axios.get(`${base_url}filter-projects`, {
          params: filteredParams,
        });
        properties.value = response.data.data;
        projectCount.value = response.data.data.length;
      } catch (error) {
        console.error("Failed to fetch properties by city ID:", error.message);
      }
    };

    onMounted(() => {
      getCitiesWithProjectCounts(), getProjects();
      getPropertyTypes();
    });

    return {
      projectCount,
      handlePropertiesByCityId,
      citiesWithProjectCounts,
      keyword,
      handleBathBedSelected,
      handlePriceRangeSelected,
      handleMenuItemSelected,
      filterProjects,
      properties,
      property_types,
      project_status,
    };
  },
};
</script>
